module.exports = __webpack_public_path__ + "static/btn3-a1aa08d36fb16ba212bdc93a30becfa2.png";